// angular imports
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';

// cc-common imports
import { Utils } from 'cc-common';

// devextreme imports
import notify from 'devextreme/ui/notify';

// component imports
import { WorkOrderBaseComponent } from '../../../_base/work-order-base-component';

// constant imports
import { MessageInterval } from '../../../../_constants/messages-intervals';

// model imports
import { FileInfoDisplayResultDto } from '../../../../_models/file-info-display-result-dto';
import { BaseWorkOrderProposalParameterDto } from '../../../_models/base-work-order-proposal-parameter-dto';
import { WorkOrderDocumentAttachRawDto } from '../../../_models/work-order-document-attach-raw-dto';
import { WorkOrderVendorProposalAddDocumentParametersDto } from '../../../_models/work-order-vendor-proposal-add-document-parameters-dto';
import { VendorProposalQuoteAttachmentParametersDto } from '../../../_models/vendor-proposal-quote-attachment-parameters-dto';

@Component({
    selector: 'app-manage-quotes',
    templateUrl: './manage-quotes.component.html',
    styleUrls: ['./manage-quotes.component.scss']
})
export class ManageQuotesComponent extends WorkOrderBaseComponent implements OnInit {
    @Input() communityId: number;
    @Input() customerId: string;
    @Input() workOrderId: number;
    @Input() workOrderProposalId: number;

    @Output() onClose = new EventEmitter<void>();

    showProposalQuote = false;
    selectedProposalQuotes: Array<FileInfoDisplayResultDto> = [];

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.populateProposalQuotes();
    }

    private populateProposalQuotes(): void {
        const baseParam: BaseWorkOrderProposalParameterDto = new BaseWorkOrderProposalParameterDto();
        baseParam.communityId = this.communityId;
        baseParam.workOrderId = this.workOrderId;
        baseParam.workOrderProposalId = this.workOrderProposalId;

        this.workOrderHelperService.showLoading();
        this.workOrderService.getProposalQuotes(baseParam).subscribe(
            (result: FileInfoDisplayResultDto[]) => {
                this.selectedProposalQuotes = result;
                this.showProposalQuote = true;
                this.workOrderHelperService.hideLoading();
            },
            (error) => {
                this.errorService.displayError(error);
                this.workOrderHelperService.hideLoading();
            }
        );
    }

    onAttachmentUpdate(allFiles: Array<any>): void {
        allFiles.forEach((file) => {
            if (Utils.notNullAndDefined(file['action'])) {
                const document: WorkOrderDocumentAttachRawDto = new WorkOrderDocumentAttachRawDto();
                if (Utils.notNullAndDefined(file.fileId)) {
                    document.fileId = file.fileId;
                    document.communityId = this.communityId;
                    if (Utils.notNullAndDefined(this.customerId)) {
                        document.customerId = this.customerId;
                    }
                }
                document.fileBase64String = Utils.notNullAndDefined(file.fileBase64String)
                    ? file.fileBase64String
                    : null;
                document.fileName = Utils.notNullAndDefined(file.fileName) ? file.fileName : file.name;

                const baseParam: WorkOrderVendorProposalAddDocumentParametersDto =
                    new WorkOrderVendorProposalAddDocumentParametersDto();
                baseParam.communityId = this.communityId;
                baseParam.workOrderProposalId = this.workOrderProposalId;
                baseParam.document = document;

                this.workOrderHelperService.showLoading();
                this.workOrderService.uploadProposalQuote(baseParam).subscribe(
                    (result: any) => {
                        this.workOrderHelperService.hideLoading();
                        setTimeout(() => {
                            this.populateProposalQuotes();
                        }, 200);
                    },
                    (error) => {
                        this.errorService.displayError(error);
                        this.workOrderHelperService.hideLoading();
                    }
                );
            }
        });
    }

    onAttachmentDelete(file: FileInfoDisplayResultDto): void {
        const baseParams: VendorProposalQuoteAttachmentParametersDto = new VendorProposalQuoteAttachmentParametersDto();
        baseParams.communityId = this.communityId;
        baseParams.fileId = file.fileId;
        baseParams.workOrderId = this.workOrderId;
        baseParams.workOrderProposalId = this.workOrderProposalId;

        this.workOrderHelperService.showLoading();
        this.workOrderService.deleteProposalQuote(baseParams).subscribe(
            (result: any) => {
                notify('Quote deleted successfully.', 'Success', MessageInterval.successMsgInterval);
                this.populateProposalQuotes();
                this.workOrderHelperService.hideLoading();
            },
            (error) => {
                this.errorService.displayError(error);
                this.workOrderHelperService.hideLoading();
            }
        );
    }

    onAttachmentUploaderClose(): void {
        this.showProposalQuote = false;
        this.onClose.emit();
    }
}
